import React, { useEffect, useRef } from "react";
import _ from "lodash";
import Utils from "../../Utils";

/**
 * props:
 * - images: [{id, src, title, date}]
 * - activeId
 * - onSelect(id)
 */
const ThumbnailList = ({
  images = [],
  mode,
  activeId,
  origid,
  onSelect = () => {},
}) => {
  const activeRef = useRef(null);

  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, [activeId]);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const thumbpath = ["sdeck", "recce"].includes(mode) ? "recce" : "photo";

  const clickPath = (img) => {
    if (["sdeck", "recce"].includes(mode)) {
      return `${process.env.PUBLIC_URL}/photoshoot-recce/${img.photoshoot_id}/${mode}/${img.fname}`;
    } else {
      return `${process.env.PUBLIC_URL}/view-feedback/${img.photoshoot_id}/${img.id}/${img.fname}`;
    }
  };

  function reorderPhotos(data) {
    const grouped = _.groupBy(data, "orig_photo_id");
    const seen = new Set();

    return _.flatMap(data, (item) => {
      if (seen.has(item.id)) return [];

      const children = grouped[item.id] || [];
      children.forEach((child) => seen.add(child.id));

      return [item, ...children];
    });
  }

  const getFileName = (path) =>
    path
      .split(/[/\\]/)
      .pop()
      .replace(/\.[^/.]+$/, "");

  const renderImageStatus = (img) => {
    if (mode !== "photos") return <></>;
    const statuses = {
      submitted: ["Pending", "bg-yellow-300"],
      "bt-rejected": ["Edits Needed", "bg-red-300"],
      "bt-processed": ["Approved", "bg-green-300"],
      "bt-approved": ["Approved", "bg-green-300"],
      "ai-processed": ["Pending", "bg-yellow-300"],
      "bt-edits-uploaded": ["Edits Uploaded", "bg-gray-300"],
    };
    const alreadyHasNewerVersion =
      _.get(
        images.find((i) => i.orig_photo_id === img.id),
        "id",
        null,
      ) != null;

    if (img.status == "bt-rejected" && alreadyHasNewerVersion) {
      img.status = "bt-edits-uploaded";
    }

    return (
      <div
        className={`z-100 rounded p-1 ${statuses[img.status][1]} flex justify-center gap-1`}
      >
        <span className="text-end text-xs">{statuses[img.status][0]}</span>
      </div>
    );
  };

  return (
    <div className="thumb-list" aria-label="Image thumbnails">
      {reorderPhotos(images).map((img, idx) => (
        <div
          key={img.id}
          ref={activeId === img.id ? activeRef : null}
          role="button"
          tabIndex={0}
          data-id={img.id}
          /* onClick={() => onSelect(img.id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onSelect(img.id);
            }
          }} */
          className={`thumb-item ${activeId === img.id ? "active" : ""} ${Utils.getSetColors(img.setnum)}`}
        >
          {renderImageStatus(img)}
          <a href={clickPath(img)}>
            <img
              className="thumb-img"
              src={`${process.env.REACT_APP_API_URL}/photoshoot/${thumbpath}/thumb/${img.fname}`}
              alt={img.origname}
            />
            <div className="thumb-meta">
              {/*<div className="thumb-date">{formatDate(img.created_at)}</div>*/}
              {/*<div className="thumb-date">{getFileName(img.filename)}</div>*/}
              <div className="thumb-date">{img.origname}</div>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export default ThumbnailList;
